import React, { useMemo, ReactElement } from 'react';
import FilterContainer from '../../../components/filter-container/filter-container.component';
import FilterSelectField from '../../../components/filter-select-field/filter-select-field.component';
import MenuItemList from '../../../components/menu-item-list/menu-item-list.component';
import { FILTER_VALUE_EMPTY } from '../../../constants/system/filter-values';
import { FILTER_TYPE_CONTACT_ID, FILTER_TYPE_STATUS } from '../../../constants/system/filter-types';

const DealTasksFilters: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    filters,
    currentFilters,
    currentUser,
    filterDealTaskContactList,
    dealTaskStatusList,
    onSetFilterValue,
  } = props;

  const filterContactId: number = filters && filters[FILTER_TYPE_CONTACT_ID];
  const filterStatus: string = filters && filters[FILTER_TYPE_STATUS];
  const currentUserId: number = currentUser && currentUser.id;

  const menuItemFilterDealTaskContactList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'fullName',
    optionList: filterDealTaskContactList,
    selectedValue: filterContactId,
    labelCallback: (contactItem: Contact): string | null => (
      contactItem.user && contactItem.user.id === currentUserId ? 'Assigned to me' : null
    ),
  }), [filterDealTaskContactList, filterContactId, currentUserId]);

  const menuItemFilterDealTaskStatusList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: dealTaskStatusList,
    selectedValue: filterStatus,
  }), [dealTaskStatusList, filterStatus]);

  return (
    <FilterContainer>
      {
        filterDealTaskContactList && !!filterDealTaskContactList.length && (
          <FilterSelectField
            isInteger
            filterType={FILTER_TYPE_CONTACT_ID}
            label="Assigned To"
            value={currentFilters[FILTER_TYPE_CONTACT_ID] || FILTER_VALUE_EMPTY}
            currentFilters={currentFilters}
            menuItemList={menuItemFilterDealTaskContactList}
            onSetFilterValue={onSetFilterValue}
          />
        )
      }
      <FilterSelectField
        filterType={FILTER_TYPE_STATUS}
        label="Status"
        value={currentFilters[FILTER_TYPE_STATUS] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterDealTaskStatusList}
        onSetFilterValue={onSetFilterValue}
      />
    </FilterContainer>
  );
});

export default DealTasksFilters;
